export const negatePositiveNumber = (number?: number | string): number | undefined => {
  if (typeof number === 'string') {
    const parsedNumber = parseInt(number, 10);
    return parsedNumber && parsedNumber > 0 ? parsedNumber * -1 : parsedNumber;
  }
  return number && number > 0 ? number * -1 : number;
};
